export const PARAMETER_RR_ID = 0;
export const PARAMETER_TV_ID = 1;
export const PARAMETER_PT_ID = 2;
export const PARAMETER_KD_ID = 3;
export const PARAMETER_EL_CO_2_ID = 4;
export const PARAMETER_LAK_ID = 5;
export interface StateParameter {
    id: number;
    value: number;
}